import React, { Component } from 'react';
import ActivitesCardsList from '../../components/homepage-cards/activities-cards/ActivitesCardsList';
import { lang } from '../../lang';
import { withTranslation } from 'react-i18next';
class HomepageFifth extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        const { t, i18n } = this.props;
        return (
            <div className='hp hp-fifth'>
                <div className='fifth-statement'>
                    <h2>{t('homepage.training.title')}</h2>
                    <h5>{t('homepage.training.desc')}</h5>
                </div>
                <div className='carousel-container'>
                    <ActivitesCardsList
                        courses={this.props.courses}
                        files={this.props.files}
                    />
                </div>
            </div>
        );
    }
}

export default withTranslation()(HomepageFifth);
